<template>
  <div>
    <div class="vx-row min-h-screen">
      <div class="vx-col w-full">
        <header-public></header-public>
      </div>
      <div class="vx-col w-full legal-text">
        <div class="container w-full max-w-5xl mx-auto px-3 py-12">
          <div class="vx-row">
            <div class="vx-col w-full">
              <a href="/" class="link-back">{{ $t('GoHome') }}</a>
              <h1>{{ $t('cookies.Policy') }}</h1>
              <p>
                {{ $t('cookies.PolicyText1') }}
                <a href="https://www.barify.es/" target="_blank">https://www.barify.es/</a> {{ $t('cookies.PolicyText2') }}
              </p>
              <p>
                {{ $t('cookies.PolicyText3') }}
              </p>
              <h2>{{ $t('cookies.WhatIsIt') }}</h2>
              <p>
                {{ $t('cookies.WhatIsIt2') }}
              </p>
              <p>
                {{ $t('cookies.WhatIsIt3') }}
              </p>
              <h2>{{ $t('cookies.Use') }}</h2>
              <p>
                {{ $t('cookies.Use1') }}
              </p>
              <p>
                {{ $t('cookies.Use2') }}
              </p>
              <p>
                {{ $t('cookies.Use3') }}
              </p>
              <p>
                {{ $t('cookies.Use4') }}
              </p>
              <h2>{{ $t('cookies.Types') }}</h2>
              <p>
                {{ $t('cookies.Types1') }}
              </p>
              <h3>{{ $t('cookies.Property') }}</h3>
              <p>
                {{ $t('cookies.Property1') }}
              </p>
              <p>
                {{ $t('cookies.Property2') }}
              </p>
              <h3>{{ $t('cookies.LifeTime') }}</h3>
              <p>
                {{ $t('cookies.LifeTime1') }}
              </p>
              <p>
                {{ $t('cookies.LifeTime2') }}
              </p>
              <h3>{{ $t('cookies.Finality') }}</h3>
              <p>
                {{ $t('cookies.Finality2') }}
              </p>
              <p>
                {{ $t('cookies.Finality3') }}
              </p>
              <p>
                {{ $t('cookies.Finality4') }}
              </p>
              <p>
                {{ $t('cookies.Finality5') }}
              </p>
              <p>
                {{ $t('cookies.Finality6') }}
              </p>
              <h3>{{ $t('cookies.Finality7') }}</h3>
              <p>{{ $t('cookies.Finality8') }}</p>
              <h3>{{ $t('cookies.Finality9') }}</h3>
              <p>{{ $t('cookies.Finality10') }}</p>
              <p>
                {{ $t('cookies.Finality11') }}
              </p>
              <p>
                {{ $t('cookies.Finality12') }}
              </p>
              <h3>{{ $t('cookies.Finality13') }}</h3>
              <p>
                {{ $t('cookies.Finality14') }}
              </p>
              <p>
                {{ $t('cookies.Finality15') }}
              </p>
              <p>{{ $t('cookies.Info') }}</p>
              <p>GOOGLE ANALITYCS:</p>
              <p>https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage</p>
              <p>Google ADSERVICES / SYNDICATION</p>
              <p>https://www.google.com/policies/technologies/ads/</p>
              <h2>{{ $t('cookies.UserConfig') }}</h2>
              <p>
                {{ $t('cookies.LegalRegulations') }}
              </p>
              <p>
                {{ $t('cookies.Block') }}
              </p>
              <p>
                {{ $t('cookies.Block1') }}
              </p>
              <p>{{ $t('cookies.Block2') }}</p>
              <p>{{ $t('cookies.Block3') }}</p>
              <p>{{ $t('cookies.Block4') }}</p>
              <p>
                {{ $t('cookies.Help') }}
              </p>
              <p>
                {{ $t('cookies.PrivateMode') }}
              </p>
              <p>{{ $t('cookies.Explorer') }}</p>
              <p>{{ $t('cookies.Firefox') }}</p>
              <p>{{ $t('cookies.Chrome') }}</p>
              <p>{{ $t('cookies.Safari') }}</p>
              <p>{{ $t('cookies.Opera') }}/p>
              <p>
                {{ $t('cookies.FurtherInfo') }}
              </p>
              <p>
                {{ $t('cookies.Deactivate') }}
              </p>
              <p>
                {{ $t('cookies.Deactivate') }}
                <a href="mailto:info@servipyme.es">info@servipyme.es</a>.
              </p>
              <p>{{ $t('cookies.LastUpdate') }}</p>
              <a href="/" class="link-back">{{ $t('GoHome') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full self-end">
        <footer-public></footer-public>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPublic from '../../components/Public/Header';
import FooterPublic from '../../components/Public/Footer';

export default {
  components: {
    HeaderPublic,
    FooterPublic,
  },
  data () {
    return {};
  },
};
</script>

<style></style>
